import { useEffect } from 'react';
import { useEditor } from '@/store/editor';

export function Toast() {
  const toast = useEditor((s) => s.toast);
  const setToast = useEditor((s) => s.setToast);

  useEffect(() => {
    if (!toast) return;
    const id = setTimeout(() => setToast(null), 2400);
    return () => clearTimeout(id);
  }, [toast, setToast]);

  return (
    <div
      className={`fixed bottom-[220px] left-1/2 -translate-x-1/2 bg-bg-elevated border border-border-strong px-4 py-2.5 rounded-lg text-sm flex items-center gap-2 shadow-xl z-[90] transition-all ${
        toast ? 'opacity-100 -translate-y-1' : 'opacity-0 pointer-events-none'
      }`}
    >
      <div className="w-1.5 h-1.5 rounded-full bg-green-500" />
      <span>{toast}</span>
    </div>
  );
}
